export function getDecimal(num: number) {
  let result;
  const initialNum = Math.abs(num);
  const roundedNum = Math.round(initialNum);

  if (roundedNum > initialNum) {
    result = roundedNum - initialNum - 1;
    result = Math.abs(result);
    result = +result.toFixed(10);
  } else {
    result = initialNum - roundedNum;
    result = +result.toFixed(10);
  }
  return result;
}

/**
 * Математическое округление до places знаков после запятой
 * @param num - число
 * @param [places=2] - кол-во знаков после запятой
 * @returns {number}
 * @example round(2.356); // 2.36
 * @example round(2.369, 1); // 2.4
 */
export const round = (num: number, places = 2) =>
  +`${Math.round(+`${num.toFixed(9)}e+${places}`)}e-${places}`;

export default {
  getDecimal,
};
